module.exports = __webpack_public_path__ + "img/advisor3-icon.197a2acd.svg";